import { useToast } from '@contexts/ToastContext';
import { useLanguage } from '@contexts/LanguageContext';

export const useNotification = () => {
    const toast = useToast();
    const { t } = useLanguage();

    const notify = {
        success: (message, options = {}) => {
            return toast.success(message, {
                // title: t('common.success'),
                ...options
            });
        },

        error: (message, options = {}) => {
            return toast.error(message, {
                // title: t('common.error'),
                duration: 6000,
                ...options
            });
        },

        warning: (message, options = {}) => {
            return toast.warning(message, {
                // title: t('common.warning'),
                ...options
            });
        },

        info: (message, options = {}) => {
            return toast.info(message, {
                // title: t('common.info'),
                ...options
            });
        },

        // Convenience methods for common scenarios
        saveSuccess: () => notify.success(t('common.saveSuccess')),
        saveError: () => notify.error(t('common.saveError')),
        deleteSuccess: () => notify.success(t('common.deleteSuccess')),
        deleteError: () => notify.error(t('common.deleteError')),
        uploadSuccess: () => notify.success(t('common.uploadSuccess')),
        uploadError: () => notify.error(t('common.uploadError')),
    };

    return notify;
};